import loadable from 'utils/loadable';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "modal.withdrawal" */ './ModalWithdrawUnavailable.component'
    ),
);
